import React, { useState } from "react";
import "./CreateAdmin.css";
import { backend_url } from "../../App";

const CreateAdmin = () => {
  const [formData, setFormData] = useState({
    admname: "",
    admemail: "",
    admpassword: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const createAdmin = async () => {
    if (!formData.admname || !formData.admemail || !formData.admpassword) {
      alert("Please fill in all fields");
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${backend_url}/admsignup`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("auth-token"),
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        alert("Admin account created successfully!");
        setFormData({
          admname: "",
          admemail: "",
          admpassword: "",
        });
      } else {
        alert(data.errors || "Failed to create admin account");
      }
    } catch (error) {
      alert("Error creating admin account: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="create-admin">
      <div className="create-admin-container">
        <h1>Create New Admin Account</h1>
        <div className="create-admin-fields">
          <input
            type="text"
            placeholder="Admin Name"
            name="admname"
            value={formData.admname}
            onChange={changeHandler}
            required
          />
          <input
            type="email"
            placeholder="Email Address"
            name="admemail"
            value={formData.admemail}
            onChange={changeHandler}
            required
          />
          <input
            type="password"
            placeholder="Password"
            name="admpassword"
            value={formData.admpassword}
            onChange={changeHandler}
            required
          />
        </div>
        <button
          onClick={createAdmin}
          disabled={isLoading}
          className="create-admin-btn"
        >
          {isLoading ? "Creating..." : "Create Admin Account"}
        </button>
      </div>
    </div>
  );
};

export default CreateAdmin;
